import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './page-title.less';

interface IPageTitle {
  title: string,
  back?: boolean,
  children?: React.ReactNode,
  onBack?: () => void,
  subTitle?: string;
}

const PageTitle = ({
  title, back, children, onBack, subTitle,
}: IPageTitle): JSX.Element => {
  const { goBack } = useHistory();

  const backBtnHandler = () => {
    if (onBack) {
      onBack();
    }
    goBack();
  };

  return (
    <div className="header">
      {back && (
        <button
          type="button"
          className="header__go-back"
          // eslint-disable-next-line react/jsx-no-bind
          onClick={backBtnHandler}
        >
          <ArrowLeftOutlined />
        </button>
      )}
      <div className="header__wrapper">
        <div className="header__titles">
          <h2 className="header__title">{title}</h2>
          {subTitle && <h6 className="header__subtitle">{subTitle}</h6>}
        </div>
        {children}
      </div>
    </div>
  );
};

PageTitle.displayName = 'PageTitle';

export default PageTitle;
